import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import pluralize from 'rebook/apps/utils/text/pluralize';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import TagList from 'rebook/apps/catalog/components/TagList';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import { SORT_BY_NEW_POPULAR_AUTHORS } from 'rebook/apps/base/constants';
import * as TagListActions from 'rebook/apps/catalog/actions/TagListActions';

import styles from './style.scss';


class TagListView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(TagListActions.fetchInitialData(match));
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match, location } = this.props;
    this.props.TagListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.TagListActions.resetData();
  }

  changePage(pageNumber) {
    this.props.TagListActions.fetchTagsList({ pageNumber });
  }

  changeOrderBy(orderBy) {
    this.props.TagListActions.fetchTagsList({ orderBy, pageNumber: 1 });
  }

  resetFilters() {
    this.props.TagListActions.fetchTagsList({ orderBy: 'asc' });
  }

  getTagsCounterBlock(totalAuthorsCount) {
    const counterText = `${pluralize(totalAuthorsCount, 'тема', 'темы', 'тем')}`;
    if (totalAuthorsCount === null) {
      return (
        <div className={styles.countEmpty} />
      );
    }

    return (
      <div className={styles.count}>
        <span>
          {totalAuthorsCount}&nbsp;{counterText}
        </span>
      </div>
    );
  }

  render() {
    const { tagList } = this.props;
    const { list, lastPageNumber, pageNumber, orderBy, totalAuthorsCount } = tagList;

    return (
      <div className="section">
        <BreadCrumbs links={[
          { text: 'Библиотека', url: '/catalog/' },
          { text: 'Темы', url: '' },
        ]} />
        <div className="sectionHeader">
          <h1>Все темы</h1>
        </div>
        {this.getTagsCounterBlock(totalAuthorsCount)}
        <CatalogFilter
          orderBy={orderBy}
          orderByValues={SORT_BY_NEW_POPULAR_AUTHORS}
          isSubscriptionEnabled={false}
          isBookTypeEnabled={false}
          isResultEmpty={list && list.length === 0}
          onChangeOrder={(value) => this.changeOrderBy(value)}
          onResetFilter={()=> this.resetFilters()} />
        {(tagList && list) && (
          <div className={styles.list}>
            <TagList tags={list} orderBy={orderBy} />
          </div>
        )}
        {(list === null) && (
          <TagList tags={[...Array(100)]} />
        )}
        {(lastPageNumber > 1 && list && list.length > 0) && (
          <ContextPagination
            extraClassName="jest-tags-list-pagination"
            onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
            currentPage={pageNumber}
            lastPage={lastPageNumber} />
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  tagList: state.tagList,
});

const mapDispatchToProps = (dispatch) => ({
  TagListActions: bindActionCreators(TagListActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagListView);
